var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{staticClass:"ZFFormItem",class:{ 'not-empty': _vm.fieldValue },attrs:{"prop":_vm.prop},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"label",fn:function(){return [_c('label',{staticClass:"zf-form-item-label"},[_vm._v(_vm._s(_vm.label))])]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }